import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Divider from '@material-ui/core/Divider';

import ORTypography from 'components/ORTypography/ORTypography';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
  hasDivider: PropTypes.bool,
};

const defaultProps = {
  hasDivider: false,
};

export function UnstyledORContentHeader({ children, hasDivider, classes }) {
  return (
    <React.Fragment>
      <ORTypography variant="h5" component="h1" className={classes.header}>
        {children}
      </ORTypography>
      {hasDivider && <Divider className={classes.divider} />}
    </React.Fragment>
  );
}

UnstyledORContentHeader.defaultProps = defaultProps;
UnstyledORContentHeader.propTypes = propTypes;

const styles = (theme) => ({
  header: {
    color: theme.palette.text.primary,
    fontSize: '1.285714rem',
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
});

export default withStyles(styles)(UnstyledORContentHeader);
